import { createSelector } from 'reselect';

const selectZones = (state: any) => state.zones;


export const selectZonesCurrentItem = createSelector([selectZones], (zones) => zones.current);

export const selectZonesListItems = createSelector([selectZones], (zones) => zones.list);

export const selectZonesItemById = (itemId: any) =>
    createSelector(selectZonesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectZonesQueryItems = createSelector([selectZones], (zones) => zones.query);

export const selectZonesCreatedItem = createSelector([selectZones], (zones) => zones.create);

export const selectZonesUpdatedItem = createSelector([selectZones], (zones) => zones.update);

export const selectZonesReadItem = createSelector([selectZones], (zones) => zones.read);

export const selectZonesDeletedItem = createSelector([selectZones], (zones) => zones.delete);

export const selectZonesSearchedItems = createSelector([selectZones], (zones) => zones.search);

export const selectZonesItemsCount = createSelector([selectZones], (zones) => zones.count);

export const selectZonesItemsFilter = createSelector([selectZones], (zones) => zones.filter);